import WhackAMole from './WhackAMole.vue';
import WhackAMoleList from './WhackAMoleList.vue';
export default {
  WhackAMole,
  WhackAMoleList,
};
